var _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Service, { inject as service } from '@ember/service';
import assert from '@banking/ui/utils/assert';
let CheckingSettingsMenu = (_class = class CheckingSettingsMenu extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "dataApi", _descriptor2, this);
    _initializerDefineProperty(this, "applicationRouter", _descriptor3, this);
  }
  getSettingsMenuRows(options) {
    const {
      canSeeSquareCard,
      bizbankEnabled,
      shouldShowCheckingRebrand,
      canSeeCheckingStatements,
      canSeeTransferSettings,
      canSeeDisputes,
      unitToken,
      primaryCardToken
    } = options;
    const rows = [];
    if (canSeeSquareCard) {
      if (bizbankEnabled) {
        rows.push({
          className: 'banking-header--shim__settings-menu-row',
          icon: 'card-swipe',
          title: shouldShowCheckingRebrand ? this.intl.t('banking.checking.header.nav.dropdown.checkingSettings') : this.intl.t('banking.checking.header.nav.dropdown.cardSettings'),
          onClick: () => this.handleCheckingSettingsClick(unitToken, primaryCardToken)
        });
      } else {
        rows.push({
          className: 'banking-header--shim__settings-menu-row',
          icon: 'card-swipe',
          title: shouldShowCheckingRebrand ? this.intl.t('banking.checking.header.nav.dropdown.checkingLanding') : this.intl.t('banking.checking.header.nav.dropdown.cardLanding'),
          onClick: () => this.handleSquareCardClick(unitToken)
        });
        if (canSeeCheckingStatements) {
          rows.push({
            className: 'banking-header--shim__settings-menu-row',
            icon: 'chart-bar',
            title: this.intl.t('banking.statements.header.nav.title.checking'),
            onClick: () => this.handleCheckingStatementsClick(unitToken)
          });
        }
      }
    }
    if (canSeeTransferSettings) {
      rows.push({
        className: 'banking-header--shim__settings-menu-row',
        icon: 'right-left',
        title: this.intl.t('banking.checking.header.nav.dropdown.transferSettings'),
        onClick: () => this.handleTransferSettingsClick(unitToken)
      });
    }
    if (canSeeDisputes) {
      rows.push({
        className: 'banking-header--shim__settings-menu-row',
        icon: 'loud-speaker',
        title: this.intl.t('banking.checking.header.nav.dropdown.disputes'),
        onClick: () => this.handleDisputesClick(unitToken)
      });
    }
    return rows.length > 0 ? rows : null;
  }
  handleCheckingSettingsClick(unitToken, primaryCardToken) {
    assert(typeof unitToken === 'string');
    this.dataApi.track('Click Checking Overview', {
      action: 'Click',
      applet: 'Banking',
      feature: 'Square Checking Home',
      page: 'Checking Overview',
      target: 'Navigate To Checking Settings'
    });
    if (typeof primaryCardToken === 'string') {
      this.applicationRouter.transitionTo('banking.card-settings', unitToken, primaryCardToken);
    } else {
      this.applicationRouter.transitionTo('money.square_card.manage', {
        queryParams: {
          unitToken
        }
      });
    }
  }
  handleSquareCardClick(unitToken) {
    this.applicationRouter.transitionTo('money.square_card.manage', {
      queryParams: {
        unitToken
      }
    });
  }
  handleCheckingStatementsClick(unitToken) {
    // setting returnTo to null to avoid sticky query for statements page
    // go back to previous page by default, this is set up in the statements MFE
    this.applicationRouter.transitionTo('banking.statements', {
      queryParams: {
        unitToken,
        returnTo: null
      }
    });
  }
  handleTransferSettingsClick(unitToken) {
    this.dataApi.track('Click Checking Overview', {
      action: 'Click',
      applet: 'Banking',
      page: 'Checking Overview',
      target: 'Navigate To Transfer Settings'
    });
    this.applicationRouter.transitionTo('money.settings', {
      queryParams: {
        currentUnitToken: unitToken
      }
    });
  }
  handleDisputesClick(unitToken) {
    this.dataApi.track('Click Checking Overview', {
      action: 'Click',
      applet: 'Banking',
      page: 'Checking Overview',
      target: 'Navigate To Square Card Disputes'
    });
    this.applicationRouter.transitionTo('square-card.disputes', {
      queryParams: {
        unitToken
      }
    });
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "dataApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "applicationRouter", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { CheckingSettingsMenu as default };